import UAParser from 'ua-parser-js';

export const ClientUAInstance = new UAParser();

export const browser = ClientUAInstance.getBrowser();
export const cpu = ClientUAInstance.getCPU();
export const device = ClientUAInstance.getDevice();
export const engine = ClientUAInstance.getEngine();
export const os = ClientUAInstance.getOS();
export const ua = ClientUAInstance.getUA();
export const setUa = (userAgentString: string): UAParser.UAParserInstance =>
  ClientUAInstance.setUA(userAgentString);

export const parseUserAgent = (
  userAgent: string | undefined
):
  | {
      UA: UAParser.UAParserInstance;
      browser: UAParser.IBrowser;
      cpu: UAParser.ICPU;
      device: UAParser.IDevice;
      engine: UAParser.IEngine;
      os: UAParser.IOS;
      ua: string;
      setUserAgent: (userAgentString: string) => UAParser.UAParserInstance;
    }
  | undefined => {
  if (!userAgent) {
    console.error('No userAgent string was provided');
    return;
  }

  const UserAgentInstance = new UAParser(userAgent);

  return {
    UA: UserAgentInstance,
    browser: UserAgentInstance.getBrowser(),
    cpu: UserAgentInstance.getCPU(),
    device: UserAgentInstance.getDevice(),
    engine: UserAgentInstance.getEngine(),
    os: UserAgentInstance.getOS(),
    ua: UserAgentInstance.getUA(),
    setUserAgent: (userAgentString: string): UAParser.UAParserInstance =>
      UserAgentInstance.setUA(userAgentString),
  };
};
